import Handlebars from 'handlebars';

Handlebars.registerHelper('url_encode', input => {
  const isAbsoluteUrl = /^https?:\/\//i.test(input);
  if (isAbsoluteUrl) return input;
  return encodeURIComponent(input);
});

const compileHandlebarTemplate = (template, data) => {
  const compiledTemplate = Handlebars.compile(template);
  return compiledTemplate(data);
};

export default compileHandlebarTemplate;
